/**
 * HighlightedText component
 * Displays text with search terms highlighted
 */

'use client';

import { useMemo } from 'react';
import { getHighlightedSegments } from '../../utils/highlight';

interface HighlightedTextProps {
  text: string;
  query: string;
  className?: string;
  highlightClassName?: string;
}

export function HighlightedText({
  text,
  query,
  className = '',
  highlightClassName = 'bg-yellow-500/20 font-semibold text-foreground',
}: HighlightedTextProps) {
  const segments = useMemo(() => {
    return getHighlightedSegments(text, query);
  }, [text, query]);

  if (segments.length === 1 && !segments[0].isHighlighted) {
    return <span className={className}>{text}</span>;
  }

  return (
    <span className={className}>
      {segments.map((segment, index) =>
        segment.isHighlighted ? (
          <mark key={index} className={highlightClassName}>
            {segment.text}
          </mark>
        ) : (
          <span key={index}>{segment.text}</span>
        )
      )}
    </span>
  );
}
